import { SedsBadgeComponent } from './seds-badge.component';

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [SedsBadgeComponent],
  imports: [CommonModule, MatBadgeModule, MatIconModule],
  exports: [SedsBadgeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsBadgeModule {}
